<template>
  <v-card class="mx-auto mt-3" max-width="360">
    <v-card-title>Noel Tiangco</v-card-title>
    <v-card-subtitle>Application Developer</v-card-subtitle>
    <v-card-text>
      <v-containter>
        <v-row>
          <v-col>
            <p>I love enjoy playing board games and developing web applications.</p>
            <p>
              For board game suggestions and your web application questions, contact me at
              <a href="mailto:noeltiangco@technologist.com">noeltiangco@technologist.com</a>
            </p>
          </v-col>
        </v-row>
      </v-containter>
    </v-card-text>
    <v-card-actions v-if="false">
      <v-spacer></v-spacer>
      <span class="mr-1">Buy the developer coffee.</span>
      <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top" class="mt-2">
        <input type="hidden" name="cmd" value="_s-xclick" />
        <input type="hidden" name="hosted_button_id" value="RJ2EH6XY4FEYA" />
        <input
          type="image"
          src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif"
          border="0"
          name="submit"
          title="PayPal - The safer, easier way to pay online!"
          alt="Donate with PayPal button"
        />
        <img alt border="0" src="https://www.paypal.com/en_CA/i/scr/pixel.gif" width="1" height="1" />
      </form>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {};
</script>